//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import DateRangePicker from '@components/date-range-picker/DateRangePicker';
import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
import { RIGHTS_INSIGHTS_DATE_RANGE_ALIASES } from '@insights/constants/rightsInsightsConstants';
import { InsightsTrackingIds } from '@insights/insightsConstants';
import { getCustomDateRangePickerAliases } from '@instagram-account/instagramSharedUtils';
import DateString from '@models/DateString';

interface RightsInsightsDateRangeProps {
  dateRange: IAliasedDateRange;
  setDateRange: (dateRange: IAliasedDateRange) => void;
}

export const RightsInsightsDateFilter = ({
  dateRange,
  setDateRange,
}: RightsInsightsDateRangeProps) => {
  return (
    <DateFilterContainer>
      <DateRangePicker
        aliases={getCustomDateRangePickerAliases(
          dateRange.timeZone,
          RIGHTS_INSIGHTS_DATE_RANGE_ALIASES,
        )}
        maxDate={DateString.getToday(dateRange.timeZone)}
        onDateRangeChanged={(range) => setDateRange(range)}
        timeZone={dateRange.timeZone}
        trackingId={InsightsTrackingIds.RIGHTS_INSIGHTS_DATE_PICKER}
        value={dateRange}
      />
    </DateFilterContainer>
  );
};

const DateFilterContainer = styled.div`
  display: flex;
  width: calc(${({ theme }) => theme.spacings[2]} * 19);
  margin-bottom: ${({ theme }) => theme.spacings[3]};
`;
